<template>
  <div>
    <v-row class="d-flex justify-start">      
      <v-card
        class="ma-2 mt-3 pt-2"
        color="#546E7A"
        dark
        width="100% "
        height="200"
        elevation="5"
      >
      <v-card-title>
        <v-alert
        class="ml-1 d-flex justify-center"
        border="left"
        color="primary"
        elevation="2"
        style="position:absolute; z-index:1;"
        width="90%"
        height="60"
      >
        <h4 class="font-weight-bold white--text">
          <small>{{`${MonthName} ${DocYear}`  }}</small>
        </h4>
      </v-alert>
      </v-card-title>
        <v-row class="d-flex justify-center" dense>
          
          <v-col cols="6">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              >
                Sale
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              >
                <small>{{ Sale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</small>
              </h3>
            </div>
          </v-col>
          <v-col cols="6">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              >
               Customers Invoiced 
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              >
                <small>{{ CustInvoiced.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</small>
              </h3>
            </div>
          </v-col>
          <!-- <v-col cols="4">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              >
                MTDTarget
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              >
                <small></small>
              </h3>
            </div>
          </v-col> -->
        </v-row>

        <!-- <v-row dense>
          <v-col cols="12" class="px-1">
            <v-progress-linear
              class=""
              :color="percentcolor"
              height="6"
              :value="salepercent"
              stream
            ></v-progress-linear>
          </v-col>
        </v-row> -->
        <v-row class="d-flex justify-center" dense>
          <!-- <v-col cols="4">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              >
               Profit
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              >
                <small>{{ Profit }}</small>
              </h3>
            </div>
          </v-col> -->
          <v-col cols="6">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              >
                Actual Profit
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              >
                <small>{{ ActProfit }}</small>
              </h3>
            </div>
          </v-col>
          <v-col cols="6">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              >
                Profit Ratio
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              >
                <small>{{ ProfitRatio }}</small>
              </h3>
            </div>
          </v-col>
        </v-row>       
      </v-card> 
      <v-progress-linear
        indeterminate
        color="primary"
        v-show="loading"
      ></v-progress-linear>
    </v-row>
  </div>
</template>

<script>


export default {
  name: "Summarycard",
  components: {},
  props: [
    "ActProfit",
    "CustInvoiced",
    "DocMonth",
    "DocYear",
    "MTDTarget",
    "MonthName",
    "Profit",
    "ProfitRatio",
    "Sale",
  ],
  data() {
    return {      
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },    
  },
};
</script>
